const productGalleries = new WeakMap();

function restoreProductImage(item) {
	const gallery = productGalleries.get(item);
	if (!gallery) return;

	Object.entries(gallery.originalAttributes).forEach(([attribute, value]) => {
		if (value === null) gallery.image.removeAttribute(attribute);
		else gallery.image.setAttribute(attribute, value);
	});

	gallery.index = 0;
}

async function loadProductGallery(item) {
	let gallery = productGalleries.get(item);

	if (!gallery) {
		const image = item.querySelector(".pgmd__item-media > img");
		if (!image || !item.dataset.productUrl) return;

		gallery = {
			image,
			index: 0,
			media: null,
			loading: null,
			originalAttributes: {
				src: image.getAttribute("src"),
				srcset: image.getAttribute("srcset"),
				sizes: image.getAttribute("sizes"),
				width: image.getAttribute("width"),
				height: image.getAttribute("height"),
				alt: image.getAttribute("alt"),
			},
		};
		productGalleries.set(item, gallery);
	}

	if (gallery.media) {
		item.toggleAttribute("data-gallery-ready", gallery.media.length > 1);
		return;
	}

	if (gallery.loading) return gallery.loading;

	const productUrl = new URL(item.dataset.productUrl, window.location.origin);
	productUrl.pathname = `${productUrl.pathname}.js`;

	gallery.loading = fetch(productUrl)
		.then((response) => {
			if (!response.ok)
				throw new Error(
					`Unable to load product gallery: ${response.status}`,
				);
			return response.json();
		})
		.then((product) => {
			gallery.media = product.media
				.filter((media) => media.media_type === "image")
				.map((media) => {
					const imageUrl = new URL(media.src, window.location.origin);
					imageUrl.searchParams.set("width", "1200");

					return {
						src: imageUrl.href,
						width: media.width,
						height: media.height,
						alt: media.alt,
					};
				});

			if (gallery.media.length <= 1) return;

			gallery.preloads = gallery.media.map((media) => {
				const image = new Image();
				image.src = media.src;
				return image.decode().catch(() => undefined);
			});

			const imageBounds = gallery.image.getBoundingClientRect();
			item.style.setProperty(
				"--pgmd-gallery-width",
				`${imageBounds.width}px`,
			);
			item.style.setProperty(
				"--pgmd-gallery-height",
				`${imageBounds.height}px`,
			);

			const controls = document.createElement("div");
			controls.className = "pgmd__gallery-controls";
			controls.innerHTML = `
                <button type="button" class="pgmd__gallery-arrow" data-gallery-step="-1" aria-label="Image précédente">
                    <svg viewBox="0 0 24 24" aria-hidden="true"><path d="m15 18-6-6 6-6" /></svg>
                </button>
                <button type="button" class="pgmd__gallery-arrow" data-gallery-step="1" aria-label="Image suivante">
                    <svg viewBox="0 0 24 24" aria-hidden="true"><path d="m9 18 6-6-6-6" /></svg>
                </button>
            `;

			const loader = document.createElement("span");
			loader.className = "pgmd__gallery-loader";
			loader.setAttribute("role", "status");
			loader.setAttribute("aria-label", "Chargement de l’image");

			item.querySelector(".pgmd__item-media").append(controls, loader);
			item.setAttribute("data-gallery-ready", "");
		})
		.catch((error) => console.error(error))
		.finally(() => {
			gallery.loading = null;
		});

	return gallery.loading;
}

document.addEventListener(
	"click",
	async (event) => {
		const arrow = event.target.closest(".pgmd__gallery-arrow");

		if (arrow) {
			event.preventDefault();
			event.stopPropagation();
			event.stopImmediatePropagation();

			const item = arrow.closest("product-group-item-maxdesign");
			const gallery = productGalleries.get(item);
			if (
				!gallery?.media?.length ||
				item.hasAttribute("data-gallery-loading")
			)
				return;

			const nextIndex =
				(gallery.index +
					Number(arrow.dataset.galleryStep) +
					gallery.media.length) %
				gallery.media.length;

			item.setAttribute("data-gallery-loading", "");
			item.setAttribute("aria-busy", "true");

			try {
				await gallery.preloads[nextIndex];
				gallery.index = nextIndex;

				const media = gallery.media[gallery.index];
				gallery.image.removeAttribute("srcset");
				gallery.image.src = media.src;
				gallery.image.width = media.width;
				gallery.image.height = media.height;
				gallery.image.alt =
					media.alt ||
					gallery.originalAttributes.alt ||
					item.dataset.title;
			} finally {
				item.removeAttribute("data-gallery-loading");
				item.removeAttribute("aria-busy");
			}
			return;
		}

		const zoomButton = event.target.closest(".pgmd__item-zoom");

		if (zoomButton) {
			const item = zoomButton.closest("product-group-item-maxdesign");

			if (item.hasAttribute("data-zoom")) {
				queueMicrotask(() => restoreProductImage(item));
			} else {
				const zoomedItem = item.parentElement.querySelector(
					"product-group-item-maxdesign[data-zoom]",
				);
				if (zoomedItem && zoomedItem !== item)
					queueMicrotask(() => restoreProductImage(zoomedItem));
				loadProductGallery(item);
			}

			return;
		}

		const zoomedItem = event.target.closest(
			"product-group-item-maxdesign[data-zoom]",
		);
		if (zoomedItem) queueMicrotask(() => restoreProductImage(zoomedItem));
	},
	true,
);

document.addEventListener("dialog:after-hide", (event) => {
	event.target
		.querySelectorAll("product-group-item-maxdesign[data-gallery-ready]")
		.forEach((item) => restoreProductImage(item));
});
